import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#001435] flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-lg">
        <h1 className="text-8xl font-bold text-white mb-4">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-white mb-4">
          Page Not Found
        </h2>
        <p className="text-blue-200/60 mb-8">
          Sorry, the page you're looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white font-medium px-6 py-3 rounded-lg transition-all"
          >
            <Home className="w-5 h-5" />
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white/40 text-white font-medium px-6 py-3 rounded-lg transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
            Go Back
          </button>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-blue-200/40 text-sm mb-4">Popular pages:</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/" className="text-blue-400 hover:text-blue-300 text-sm">Home</Link>
            <span className="text-white/20">•</span>
            <Link to="/about" className="text-blue-400 hover:text-blue-300 text-sm">About Us</Link>
            <span className="text-white/20">•</span>
            <Link to="/contact" className="text-blue-400 hover:text-blue-300 text-sm">Contact</Link>
            <span className="text-white/20">•</span>
            <Link to="/blog" className="text-blue-400 hover:text-blue-300 text-sm">Blog</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
